import React from 'react'

import CowmedChip from '#/components/Chip'

const TypeChip = props => <CowmedChip {...props} />

export default TypeChip
